@if (categoriesList) {
  @if (isTabletAndDown$()) {
    <boels-vertical-aligner
      class="boels-category-sibling-navigation mobile-view-only"
    >
      <h4>{{ categoriesList.parentCategory.name }}</h4>
      <ng-select
        autofocus
        [items]="allCategories.parentCategory.subcategories || null"
        bindLabel="name"
        [ngModel]="selectedCategory"
        (change)="handleDropDownChange($event)"
        [searchable]="false"
        [clearable]="false"
      >
      </ng-select>
    </boels-vertical-aligner>
  } @else {
    <div class="boels-category-sibling-navigation desktop-view-only">
      <a [cmsRouterLink]="categoriesList.parentCategory.url">
        <h5 class="sibling-navigation-heading">
          <fa-icon [icon]="faChevronLeftIcon" size="2xs"></fa-icon>
          {{ categoriesList.parentCategory.name }}
        </h5>
      </a>
      <ng-container>
        <ul [@openClose]="!showMoreCollapsed ? 'open' : 'closed'">
          @for (
            siblingCategory of categoriesList.parentCategory.subcategories;
            track trackById($index, siblingCategory)
          ) {
            <li
              [ngClass]="{
                active: siblingCategory.id === categoriesList.activeCategory.id,
              }"
            >
              <fa-icon [icon]="faChevronRightIcon" size="2xs"></fa-icon>
              @if (siblingCategory.id !== categoriesList.activeCategory.id) {
                <a [cmsRouterLink]="siblingCategory.url">
                  <div>
                    {{ siblingCategory.name }}
                  </div>
                </a>
              } @else {
                <div class="active">
                  {{ siblingCategory.name }}
                </div>
              }
            </li>
          }
        </ul>
      </ng-container>
      @if (displayShowMore$ | async) {
        <a class="btn btn-underline btn-show-less" (click)="toggleShowMore()">
          {{
            showMoreCollapsed
              ? ('productFilter.showMore' | transloco)
              : ('productFilter.showLess' | transloco)
          }}
        </a>
      }
    </div>
  }
}
